module.exports = __webpack_public_path__ + "media/images/icons/clock-solid-icon-b5df81267c654e5b578e5b9134ee6cef.svg";